module.exports = "/fonts/opensanssemibold.woff2";